import { useAuthStore } from "../store";

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const hydrated = useAuthStore((s) => s.hydrated);
  return { user, hydrated, isAuthenticated: !!user };
}
